export default __webpack_public_path__ + "static/media/cert2.a1e5b3e3.jpg";